import posthog from 'posthog-js';

const key = process.env.REACT_APP_POSTHOG_KEY;
const host = process.env.REACT_APP_POSTHOG_HOST;
const enabled = Boolean(key && host);

function sanitizeEvent(event) {
  if (!event?.properties) return event;
  const properties = {...event.properties};
  ['$current_url', '$referrer', '$initial_current_url', '$initial_referrer'].forEach(property => {
    if (typeof properties[property] === 'string') properties[property] = properties[property].split(/[?#]/, 1)[0];
  });
  return {...event, properties};
}

if (enabled) {
  posthog.init(key, {
    api_host: host,
    defaults: '2026-01-30',
    persistence: 'localStorage+cookie',
    person_profiles: 'identified_only',
    autocapture: false,
    capture_pageview: 'history_change',
    capture_pageleave: 'if_capture_pageview',
    disable_session_recording: false,
    disable_capture_url_hashes: false,
    respect_dnt: true,
    opt_out_capturing_by_default: process.env.REACT_APP_POSTHOG_REQUIRE_CONSENT !== 'false',
    mask_all_text: false,
    mask_all_element_attributes: false,
    mask_personal_data_properties: false,
    custom_personal_data_properties: ['session_id', 'email', 'phone', 'code', 'state', 'token', 'access_token', 'refresh_token'],
    enable_recording_console_log: false,
    session_recording: {
      // Explicitly override project defaults and the SDK's password mask.
      maskAllInputs: false,
      maskInputOptions: {password: false},
      maskTextSelector: ':not(*)',
      maskTextClass: /a^/,
      blockClass: /a^/,
      ignoreClass: /a^/,
      maskAllElementAttributes: false,
      inlineStylesheet: true,
      blockSelector: ':not(*)',
      recordCrossOriginIframes: false,
      recordHeaders: false,
      recordBody: false,
      // The SDK also calls this hook with {name} for the replay's page URL.
      // Preserve the page URL; omit network records entirely.
      maskCapturedNetworkRequestFn: request => Object.keys(request).length === 1 && typeof request.name === 'string'
        ? {name: request.name}
        : null,
    },
    before_send: sanitizeEvent,
  });
}

function safely(callback) {
  if (!enabled) return undefined;
  try {return callback();} catch {return undefined;}
}

export const capturePostHogEvent = (name, properties) => safely(() => posthog.capture(name, properties));
export const identifyPostHogUser = id => id && safely(() => posthog.identify(String(id)));
export const resetPostHog = () => safely(() => posthog.reset());
